import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Shield } from "lucide-react";
import { toast } from "sonner";
import { ADMIN } from "@/constants/testIds";
import { login, setAdminCreds } from "@/lib/ddfApi";

export default function AdminLoginDialog({ open, onOpenChange, onSuccess }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      setAdminCreds(email, password);
      toast.success("Welcome back, admin!");
      onSuccess?.();
    } catch (err) {
      const msg = err?.response?.data?.detail || "Invalid credentials";
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-sm"
        data-testid={ADMIN.loginDialog}
      >
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Shield size={18} /> Admin Portal
          </DialogTitle>
          <DialogDescription>
            Sign in to manage banners, ads, promos and styling.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="adm-email">Email</Label>
            <Input
              id="adm-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid={ADMIN.loginEmail}
              placeholder="Enter email"
              autoComplete="off"
              required
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="adm-pwd">Password</Label>
            <Input
              id="adm-pwd"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid={ADMIN.loginPwdField}
              placeholder="Enter password"
              autoComplete="new-password"
              required
            />
          </div>
          {error && (
            <p
              className="text-sm text-red-600"
              data-testid={ADMIN.loginError}
            >
              {error}
            </p>
          )}
          <Button
            type="submit"
            className="w-full"
            disabled={loading}
            data-testid={ADMIN.loginSubmit}
          >
            {loading ? "Signing in…" : "Sign In"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
